<!--Header-->
<app-navbar>
    <h2>{{"JOBS_LIST.TITLE" | translate}}</h2>
</app-navbar>


<!--Search Companies v1-->
<div class="container mt-20">
    <div class="filters-section">
        <div class="col-lg-12">
            <div class="row">
                <div class="card card-body">
                    <div class="input-group mb-3">
                        <ng-select2 [(ngModel)]="selectCompanyId"
                                    *ngIf="dataLoaded"
                                    [data]=clientsNameArray
                                    [options]="singleSelect"
                                    [allowClear]="true"
                                    class="select2-input"
                                    name="companyName"
                                    placeholder="Tasteaza numele sau CUI-ul companiei...">

                        </ng-select2>
                        <div class="input-group-append">
                            <button class="green-button d-block w-100 text-center m-0"
                                    type="button"
                                    (click)="goToCompany()">
                                {{"JOBS_LIST.VIEW" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 pt-5">
            <div class="row">
                <button class="btn w-100 d-block advanced-btn" type="button" data-toggle="collapse"
                        data-target="#collapseSearch" aria-expanded="false" aria-controls="collapseExample">
                        {{"JOBS_LIST.ADVANCED" | translate}}
                    <span class="fa fa-sliders-h"></span>
                </button>
                <div class="collapse" id="collapseSearch">
                    <div class="card card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{"COMPANY.DOMANI" | translate}}</label>
                                    <ng-select2 [data]="domainsArrayValues"
                                                [options]="domainOptions"
                                                [(ngModel)]="activitySector"
                                                [placeholder]="' -- Alege o optiune -- '"
                                                [allowClear]=true
                                                name="activitySector"
                                                (valueChanged)="changeDomain($event)">
                                    </ng-select2>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{"COMPANY.SUBDOMANI" | translate}}</label>
                                    <ng-select2 [data]="subdomains"
                                                [options]="subDomainOptions"
                                                [(ngModel)]="companyActivitySubSector"
                                                [allowClear]=true
                                                [placeholder]="' -- Alege o optiune -- '"
                                                name="companyActivitySubSector">
                                    </ng-select2>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="">
                                    <label>{{"COMPANY.TYPE" | translate}}</label>
                                    <select class="form-control form-control-md" [(ngModel)]="companyType">
                                        <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                        <option value="entrepreneurial">{{"COMPANY.EDIT_ENTREPRENURIAL" | translate}}</option>
                                        <option value="multinational">{{"COMPANY.EDIT_MULTINATIONAL" | translate}}</option>
                                        <option value="stat">{{"COMPANY.EDIT_STATE" | translate}}</option>
                                        <option value="mixed">{{"COMPANY.EDIT_MIXED" | translate}}</option>

                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{"COMPANY.LEVEL_EMPLY" | translate}}</label>
                                    <select class="form-control form-control-md" [(ngModel)]="companyEmployeesLevel">
                                        <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                        <option value="micro">{{"COMPANY.MICRO_EMPLY" | translate}}</option>
                                        <option value="small">{{"COMPANY.SMALL_EMPLY" | translate}}</option>
                                        <option value="medium">{{"COMPANY.MEDIUM_EMPLY" | translate}}</option>
                                        <option value="big">{{"COMPANY.LARGE_EMPLY" | translate}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{"JOBS_LIST.RATING" | translate}}</label>
                                    <input type="number" min="1" max="5" class="form-control form-control-md"
                                           [(ngModel)]="rating">
                                </div>
                            </div>
                            <div class="col-md-3 offset-md-9">
                                <div class="col-md-12">
                                    <div class="row justify-content-between">
                                        <button class="btn btn-danger"
                                                type="button"
                                                (click)="resetForm()">
                                                {{"JOBS_LIST.RESET" | translate}}
                                            <span class="fa fa-trash"></span>
                                        </button>
                                        <button class="btn btn-primary"
                                                type="reset"
                                                (click)="companiesCall()">
                                                {{"JOBS_LIST.SEARCH" | translate}}
                                            <span class="fa fa-search"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <hr>
    <div>
        <label class="mb-0">{{"JOBS_LIST.TOTAL_RESULTS" | translate}} {{totalElements}}</label>
    </div>
    <hr>
    <div class="row mt-5 mb-5">
        <div class="col-md-3">
            <div class="d-flex align-items-center">
                <label class="mr-3 mb-0">{{"JOBS_LIST.RESULTS" | translate}} </label>
                <select (change)="onSizeChange($event)" class="form-control">
                    <option *ngFor="let size of pageSizes" [ngValue]="size">
                        {{ size }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md-6 offset-3">
            <div class="d-flex align-items-center justify-content-end">
                <div class="col-md-6 d-flex align-items-center">
                    <label class="mr-3 mb-0">{{"JOBS_LIST.SORT" | translate}} </label>
                    <select (change)="onSortChange($event)" class="form-control">
                        <option [ngValue]="undefined">{{"JOBS_LIST.CHOSE" | translate}}</option>
                        <option *ngFor="let item of sortingValues" value="{{item.value}}">{{item.name}}</option>

                    </select>
                </div>
                <div class="col-md-6 d-flex align-items-center">
                    <label class="mr-3 mb-0">{{"JOBS_LIST.ORDER" | translate}} </label>
                    <select (change)="onOrderChange($event)" class="form-control">
                        <option [ngValue]="undefined">{{"JOBS_LIST.CHOSE" | translate}}</option>
                        <option value="asc">{{"JOBS_LIST.ASC" | translate}}</option>
                        <option value="desc">{{"JOBS_LIST.DESC" | translate}}</option>
                    </select>
                </div>

            </div>
        </div>

    </div>
    <hr>


    <div class="row pt-5">
        <div class="companyBlock col-md-4" *ngFor="let company of filteredCompanies.content">
            <div class="companyWrapper" routerLink="{{company['id']}}">
                <div class="row">
                    <div class="col-4 companyLogo">
                        <img src="{{company['companyLogo'].link}}"/>
                    </div>
                    <div class="col-8 companyInfo">
                        <h2>{{company['companyName']}}</h2>
                        <p class="companyDomain">{{company['activitySector'] | titlecase}}</p>
                        <p class="companyType">{{company['companyType'] | enumTransform}}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-12 mt-5">
        <ngb-pagination class="d-flex justify-content-center"
                        [(page)]="page"
                        [pageSize]="size"
                        [maxSize]="5"
                        [collectionSize]="totalElements"
                        (pageChange)="onPageChange(page)"
        ></ngb-pagination>
    </div>


</div>
<!--Footer-->
<app-footer></app-footer>
